module.exports = __webpack_public_path__ + "img/persona-5.0f8bdee7.png";